/**
 * Prompt Pay icon URL
 * Thailand's national real-time payment system
 * Source: Airwallex documentation
 * Used for payment method selection UI
 */
export const PROMPTPAY_ICON_DATA_URL =
  'https://www.airwallex.com/docs/assets/contentful/images.ctfassets.net/c3n7jozh84hr/xLSOJpNvMp7cBKdvDln0B/eb2f53a0a3f2317750739dceff9df413/______2022-06-30_10.59.00.png';
